<script>
	import { Sketch } from "vue-color";
	import { mapState } from "vuex";

	export default {
		name: "MenuColor",
		components: {
			Sketch
		},
		data() {
			return {
				openedPicker: "",
				uuid: this.generateUUID()
			};
		},
		computed: {
			...mapState({
				template: state => state.settings.template
			}),
			colorTable() {
				return this.calculateTextColor(this.backgroundTable);
			},
			backgroundTable: {
				get() {
					return this.$store.state.settings.accentColor.background;
				},
				set(value) {
					// background = primary
					// foreground = color-second-text
					this.$store.commit("color", { slot: "background", color: value });
					this.$store.commit("color", { slot: "foreground", color: this.colorTable });
				}
			}
		},
		created() {
			// Set the colors
			if (this.template) {
				this.$store.commit("color", { slot: "background", color: this.template["color-primary"] });
				this.$store.commit("color", { slot: "foreground", color: this.template["color-second"] });
			}
		},
		mounted() {
			// close any opened color picker on menu collapse
			this.$root.$on("bv::collapse::state", () => {
				this.openedPicker = "";
			});

			document.addEventListener("click", this.onDocumentClick);
		},
		beforeDestroy() {
			document.removeEventListener("click", this.onDocumentClick);
		},
		methods: {
			// open a color picker based on its ref, close the opened picker if an empty ref is passed
			togglePicker(ref) {
				this.openedPicker = this.openedPicker == ref ? "" : ref;
			},
			// store the selected color
			updateTableColor(event) {
				this.backgroundTable = event.hex;
			},
			onDocumentClick(event) {
				const isOnComponent = typeof event.composedPath().find(el => el.id === this.uuid) !== "undefined";

				// if the click is outside the component close the list
				if (!isOnComponent) {
					this.openedPicker = "";
				}
			}
		}
	};
</script>

<template lang="html">
	<div
		:id="uuid"
		class="color"
	>
		<div class="d-flex align-center">
			<b-button
				block
				variant="light"
				class="color__button"
				size="sm"
				:title="$t('Couleur du fond de l’entete de la table principale')"
				@click="togglePicker('pickerTable')"
			>
				<div
					class="color__drop"
					:style="{
						'background-color': backgroundTable,
						color: colorTable
					}"
				/>
				<span class="color__text">{{ $t("Couleur des entêtes") }}</span>
			</b-button>

			<Sketch
				v-if="openedPicker === 'pickerTable'"
				ref="pickerTable"
				:value="backgroundTable"
				:disable-alpha="true"
				class="picker"
				@input="updateTableColor($event)"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.color {
		position: relative;

		&__button {
			display: flex;
			align-items: center;
		}

		&__text {
			margin-left: auto;
			margin-right: auto;
			display: inline-flex;
			align-items: center;
		}

		&__drop {
			border-radius: 50%;
			width: 1.8em;
			height: 1.8em;
		}
	}
	.picker {
		position: absolute;
		top: 100%;
		right: 50%;
		transform: translateX(50%);
		margin-top: 5px;
		z-index: 50;
	}
</style>
